import { Box, Link as ChakraLink, Flex, Image } from "@chakra-ui/react";
import { Link as WouterLink } from "wouter";

import { Pagination, Table } from "@nens/chakra/components";

import {
  useTablePaginationAfterQuery,
  useTablePaginationBeforeQuery,
} from "@/hooks/use-table-pagination";
import { ReportDeleteButton } from "@/reports/components/report-delete-button";

import { useProjectListQuery } from "../queries/query-projects";

export function ReportsPage() {
  const { page, setPage, tableQueryParams, pageAmountQueryParams } =
    useTablePaginationBeforeQuery();

  const tableQueryResult = useProjectListQuery(tableQueryParams);
  const pageAmountQueryResult = useProjectListQuery(pageAmountQueryParams);

  const { isLoading, tableData, itemsPerPage, numPages, toPage1, toPrevious, toNext, toLastPage } =
    useTablePaginationAfterQuery({
      tableQueryResult,
      pageAmountQueryResult,
      page,
      setPage,
    });

  return (
    <Flex p={10} flexDir="column" gap={4}>
      <Box>
        <Image alt="klimaatscan logo" h="50px" src="/assets/images/klimaatscan-logo.png" />
      </Box>
      <Table
        isLoading={isLoading}
        emptyText="Er zijn geen rapporten beschikbaar"
        themeColor="brand.primary"
        tableData={tableData}
        columnDefinitions={[
          {
            title: "Rapporten",
            renderFunction: (row) => (
              <ChakraLink to={`/reports/${row.slug}`} as={WouterLink} textDecoration="underline">
                {row.name}
              </ChakraLink>
            ),
            width: "1.6fr",
          },
          {
            title: undefined,
            renderFunction: (row) => (
              <Flex w="full" justifyContent="flex-end">
                <ReportDeleteButton report={row} />
              </Flex>
            ),
            width: "1fr",
          },
        ]}
      />
      <Flex justifyContent="center">
        <Pagination
          {...{
            itemsPerPage,
            page,
            numPages,
            toPage1,
            toPrevious,
            toNext,
            toLastPage,
            variant: "secondary",
          }}
        />
      </Flex>
    </Flex>
  );
}
